import common from "../common";
import Scene from "./Scene";
import {translate} from "../utils";

export default class SplashScene extends Scene {
    constructor() {
        super();
    }

    init() {
        super.init();

        this._bg = new PIXI.Sprite(P3.assets.texture("bg_splash_screen"));
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this._bg.interactive = true;
        this._bg.mousedown = this._bg.touchstart = () => this.end();
        this.addChild(this._bg);

        this._world = new PIXI.Sprite(P3.assets.texture("asset_background_splash_screen"));
        this._world.anchor.set(0.5);
        this._world.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._world);

        this._characters = new PIXI.Sprite(P3.assets.texture("asset_tg_splash_screen"));
        this._characters.anchor.set(0.5);
        this._characters.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this._characters.visible = false;
        this.addChild(this._characters);

        this._title = new PIXI.Sprite(P3.assets.texture("title"));
        this._title.anchor.set(0.5);
        this._title.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 140);
        this._title.visible = false;
        this.addChild(this._title);

        this._logo = new PIXI.Sprite(P3.assets.texture("logo"));
        this._logo.anchor.set(0.5);
        this._logo.position.set(common.STAGE_WIDTH * 0.5 - 310, common.STAGE_HEIGHT * 0.5 - 110);
        this._logo.visible = false;
        this.addChild(this._logo);

        this._boomerangLogo = new PIXI.Sprite(P3.assets.texture("logo_boomerang"));
        this._boomerangLogo.anchor.set(0.5);
        this.addChild(this._boomerangLogo);

        const states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_tertiary_small_out");
        states.over = P3.assets.texture("btn_tertiary_small_over");
        states.down = P3.assets.texture("btn_tertiary_small_down");
        states.icon = P3.assets.texture("icon_sound");
        states.iconAlt = P3.assets.texture("icon_sound_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.clickSoundName = "sfx_click";
        this._muteButton.overSoundName = "sfx_rollover";
        this._muteButton.visible = false;
        this._muteButton.signals.up.add(function () {
            common.saveData.data.mute = !P3.audio.isMuted();
            common.saveData.save();
        }, this);
        this.addChild(this._muteButton);

        this._playButton = P3.Button.create(
            P3.assets.texture("btn_primary_large_out"),
            P3.assets.texture("btn_primary_large_over"),
            P3.assets.texture("btn_primary_large_down"),
            P3.assets.texture("icon_play")
        );
        this._playButton.clickSoundName = "sfx_click";
        this._playButton.overSoundName = "sfx_rollover";
        this._playButton.signals.click.once(this.onPlayButtonClick, this);
        this._playButton.visible = false;
        this.addChild(this._playButton);

    }

    resize() {
        super.resize();

        this._muteButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, 90);
        this._playButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 140, common.STAGE_HEIGHT - 160);
        this._boomerangLogo.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, common.STAGE_HEIGHT - 60);

    }

    animateIn() {

        this._characters.scale.set(0.2);
        new P3.utils.TWEEN.Tween(this._characters.scale, this._tweens)
            .delay(190)
            .onStart(() => this._characters.visible = true)
            .to({x: 1, y: 1}, 410)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .start();

        this._characters.rotation = -Math.PI * 0.2;
        const a = new P3.utils.TWEEN.Tween(this._characters, this._tweens)
            .delay(190)
            .to({rotation: Math.PI * 0.01}, 410)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out);

        const b = new P3.utils.TWEEN.Tween(this._characters, this._tweens)
            .to({rotation: -Math.PI * 0.001}, 2910)
            .yoyo(true)
            .repeat(Infinity)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        a.chain(b);
        a.start();

        this._title.scale.set(0.2);
        const c = new P3.utils.TWEEN.Tween(this._title.scale, this._tweens)
            .delay(690)
            .onStart(() => this._title.visible = true)
            .to({x: 1, y: 1}, 420)
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        this._logo.scale.set(0.2);
        const d = new P3.utils.TWEEN.Tween(this._logo.scale, this._tweens)
            .delay(190)
            .onStart(() => this._logo.visible = true)
            .to({x: 1, y: 1}, 420)
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        this._muteButton.scale.set(0.2);
        const e = new P3.utils.TWEEN.Tween(this._muteButton.scale, this._tweens)
            .delay(190)
            .onStart(() => this._muteButton.visible = true)
            .to({x: 1, y: 1}, 420)
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        this._playButton.scale.set(0.2);
        const f = new P3.utils.TWEEN.Tween(this._playButton.scale, this._tweens)
            .onStart(() => this._playButton.visible = true)
            .to({x: 1, y: 1}, 420)
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        c.chain(d);
        d.chain(e);
        e.chain(f);

        c.start();
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update(dt = window.deltaTime) {
        super.update();
    }

    end() {
        this._bg.interactive = false;
        this.signals.next.dispatch();
    }

    onPlayButtonClick() {
        this.end();
    }
}